<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-row>
                <v-col sm="3" md="3"></v-col>
                <v-col sm="6" md="6">
                    <v-autocomplete :items="stud_list" v-model="lid" item-text="name" label="Search Student" dense
                        item-value="lid" filled outlined :loading="comp_load" placeholder="Search by PRN No or name"
                        @change="getData()"></v-autocomplete>
                </v-col>
                <v-col sm="3" md="3"></v-col>
            </v-row>

            <v-col cols="12" sm="12" md="12" v-if="stud_data!=''">
                <v-row class="toolbar" justify="center" align="center">
                    Learner Details
                </v-row><br>
                <v-row justify="center" align="center">
                    <!-- <v-col cols="12" sm="4" md="4" class="pt-0 pb-0">
                    <v-text-field rounded outlined color="#0F2027" flat dense v-model.trim="stud_data.registration_number" name="registration_number" label="Registration Number" disabled></v-text-field>
                </v-col> -->

                    <v-col cols="12" sm="3" md="3" class="pt-0 pb-0">
                        <v-text-field rounded outlined color="#0F2027" flat dense
                            v-model.trim="stud_data.stud_firstname" name="stud_firstname" persistent-hint
                            hint="Student's First name" label="Student's First name"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3" md="3" class="pt-0 pb-0">
                        <v-text-field rounded outlined color="#0F2027" flat dense
                            v-model.trim="stud_data.stud_middlename" name="stud_middlename" persistent-hint
                            hint="Student's Middle name" label="Student's Middle name"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3" md="3" class="pt-0 pb-0">
                        <v-text-field rounded outlined color="#0F2027" flat dense v-model.trim="stud_data.stud_lastname"
                            name="stud_lastname" persistent-hint hint="Student's Last name"
                            label="Student's Last name"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3" md="3" class="pt-0 pb-0">
                        <v-text-field rounded outlined color="#0F2027" flat dense v-model.trim="stud_data.stud_fullname"
                            name="stud_fullname" persistent-hint hint="Student's Full name"
                            label="Student's Full Name"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="4" md="4" class="pt-0 pb-0">
                        <v-text-field rounded outlined color="#0F2027" hint="Primary contact no. use for communication"
                            flat dense type="number" v-model.trim="stud_data.contact_number" name="contact_number"
                            label="Primary Contact Number"
                            persistent-hint="Primary contact no. use for communication"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="4" md="4" class="pt-0 pb-0">
                        <v-text-field rounded outlined color="#0F2027"
                            persistent-hint="Primary email use for communication"
                            hint="Primary email use for communication" flat dense
                            v-model.trim="stud_data.personal_email" name="personal_email"
                            label="Student Primary Email"></v-text-field>
                    </v-col>
                </v-row>
                <v-row class="toolbar" justify="center" align="center">
                    Primary Parent Details
                </v-row><br>
                <v-row justify="center" align="center">
                    <v-col cols="12" sm="3" md="3" class="pt-0 pb-0">
                        <v-text-field rounded outlined color="#0F2027" persistent-hint hint="Parent First name" flat
                            dense v-model.trim="stud_data.stud_parent_firstname" name="stud_firstname"
                            label="Parent First name"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3" md="3" class="pt-0 pb-0">
                        <v-text-field rounded outlined color="#0F2027" flat dense
                            v-model.trim="stud_data.stud_parent_middlename" name="stud_middlename" persistent-hint
                            hint="Parent Middle name" label="Parent Middle name"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3" md="3" class="pt-0 pb-0">
                        <v-text-field rounded outlined color="#0F2027" flat dense
                            v-model.trim="stud_data.stud_parent_lastname" name="stud_lastname" persistent-hint
                            hint="Parent Last name" label="Parent Last name"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="3" md="3" class="pt-0 pb-0">
                        <v-text-field rounded outlined color="#0F2027" flat dense
                            v-model.trim="stud_data.stud_parent_fullname" name="stud_fullname" persistent-hint
                            hint="Parent Full name" label="Parent Full name"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="4" md="4" class="pt-0 pb-0">
                        <v-text-field rounded outlined color="#0F2027" flat dense type="number"
                            v-model.trim="stud_data.parent_contact_number" name="stud_parent_contact_number"
                            persistent-hint hint="Parent primary contact use for communication"
                            label="Parent Contact Number"></v-text-field>
                    </v-col>

                    <v-col cols="12" sm="4" md="4" class="pt-0 pb-0">
                        <v-text-field rounded outlined color="#0F2027" flat dense
                            v-model.trim="stud_data.stud_parent_email" name="stud_parent_email" persistent-hint
                            hint="Parent primary email use for communication"
                            label="Parent Primary Email"></v-text-field>
                    </v-col>
                </v-row>
                <span v-if="secondary_parent!=null">
                    <v-row class="toolbar" justify="center" align="center">
                        Secondary Parent Details
                    </v-row><br>
                    <v-row justify="center" align="center">
                        <v-col cols="12" sm="3" md="3" class="pt-0 pb-0">
                            <v-text-field rounded outlined color="#0F2027" persistent-hint
                                hint="Secondary Parent First name" flat dense
                                v-model.trim="stud_data.stud_secondary_parent_firstname"
                                name="stud_secondary_parent_firstname"
                                label="Secondary Parent First name"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="3" md="3" class="pt-0 pb-0">
                            <v-text-field rounded outlined color="#0F2027" flat dense
                                v-model.trim="stud_data.stud_secondary_parent_middlename"
                                name="stud_secondary_parent_middlename" persistent-hint
                                hint="Secondary Parent Middle name" label="Secondary Parent Middle name"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="3" md="3" class="pt-0 pb-0">
                            <v-text-field rounded outlined color="#0F2027" flat dense
                                v-model.trim="stud_data.stud_secondary_parent_lastname"
                                name="stud_secondary_parent_lastname" persistent-hint hint="Secondary Parent Last name"
                                label="Secondary Parent Last name"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="3" md="3" class="pt-0 pb-0">
                            <v-text-field rounded outlined color="#0F2027" flat dense
                                v-model.trim="stud_data.stud_secondary_parent_fullname"
                                name="stud_secondary_parent_fullname" persistent-hint hint="Secondary Parent Full name"
                                label="Secondary Parent Full name"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="4" md="4" class="pt-0 pb-0">
                            <v-text-field rounded outlined color="#0F2027" flat dense type="number"
                                v-model.trim="stud_data.stud_secondary_parent_contact_number"
                                name="stud_secondary_parent_contact_number" persistent-hint
                                hint="Secondary Parent primary contact use for communication"
                                label="Secondary Parent Contact Number"></v-text-field>
                        </v-col>

                        <v-col cols="12" sm="4" md="4" class="pt-0 pb-0">
                            <v-text-field rounded outlined color="#0F2027" flat dense
                                v-model.trim="stud_data.stud_secondary_parent_email" name="stud_secondary_parent_email"
                                persistent-hint hint="Secondary Parent primary email use for communication"
                                label="Secondary Parent Primary Email"></v-text-field>
                        </v-col>
                    </v-row>
                </span>
                <v-row justify="center" dense>
                    <v-btn class="button" @click="saveBasicDertails()">Save</v-btn>
                </v-row>
            </v-col>
        </v-card>
    </div>
</template>
<script>
    import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
    import moment from "moment";
export default {
    components: {
        Breadcrumbs,
    },
        data() {
            return {
                stud_data: [],
                // extraBreadcrumbItems: [


                // ],
                // breadcrumbClass: "breadcrumb-style1",
                lid: null,
                load_tab: true,
                stud_data: "",
                snackbar_msg: "",
                color: "",
                snackbar: false,
                stud_list: [],
                comp_load:false,
                secondary_parent:null,
            };
        },

        mounted() {
            this.onload();
        },

        methods: {
            saveBasicDertails(){
                 axios
                    .post("/admission/saveBasicDertails", this.stud_data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                          this.showSnackbar("#4CAF50", "Information Updated Successfully...");
                          this.onload()
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    })
                     .finally(() => {
                        this.stud_data = [];
                        this.lid = null
                    });
            },
            onload() {
                this.comp_load = true;
                axios
                    .post("/admission/getAllStudents")
                    .then((res) => {
                        if (res.data.msg == "200") {
                            this.stud_list = res.data.stud_list;
                        } else {
                             this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        }
                    })
                    .catch((error) => {
                         this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    })
                    .finally(() => {
                        this.comp_load = false;
                    });
            },
            getData() {
                const formData = {
                    lid: this.lid,
                };
                axios
                    .post("/admission/getStudBasicData", formData)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.stud_data = res.data.stud_data;
                            this.secondary_parent = res.data.secondary_parent
                             this.comp_load = false
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!!!");
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                            this.comp_load = false
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                         this.comp_load = false
                    })
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
        },
    };
</script>
